//Compliance
export const GetAllCompliance = (locationID) => {
  return $.get('Compliance/GetAllComplianceMeasuresByLocationId?locationId=' + locationID)
}
export const GetChildsByMahcId = (machid) => {
  return $.get('Compliance/GetChildsByMahcId?mahcId=' + machid)
}
export const GetAllParentMahcCodes = () => {
  return $.get('Compliance/GetAllParentMahcCodes')
}
export const GetAllUsers = () => {
  return $.get('Compliance/GetAllUsers')
}
export const AddCompliance = (model) => {
  return $.post('Compliance/AddComplianceMeasure', model)
}
export const UpdateCompliance = (model) => {
  return $.post('Compliance/UpdateComplianceMeasureById', model)
}
export const GetAllComplianceDocuments = (LocationId) => {
  LocationId = 0
  return $.get('Compliance/GetAllComplianceDocumentsTitle?LocationId='+LocationId)
}
export const DeleteCompliance = (id) => {
  return $.post('Compliance/DeleteComplianceMeasureById?Id=' + id)
}
//Compliance Docs
export const GetAllComplianceDocs = (LocationId) => {
  return $.get('Compliance/GetAllComplianceDocumentDetailsByLocationId?locationId=' + LocationId)
}
//FG - FOOF - DEC 12 2018 - other than the URL both add and update do the exact same
//     ajax call so I combined them
export const AddOrUpdateComplianceDocument = (model,isUpdate=false) => {
  /*FG - FOOF - for loop below is for debugging
  for (var pair of model.entries())  {alert(pair[0]+ ', '+ pair[1]); }*/
  return $.ajax({
    url: isUpdate ? 'Compliance/UpdateComplianceDocumentDetailsById' : 'Compliance/AddComplianceDocumentDetail',
    data: model,
    processData: false,
    contentType: false,
    'accept-charset': 'utf-8',
    cache: false,
    type: 'POST'
  })
}
export const DeleteComplianceDoc = (id) => {
  return $.post('Compliance/DeleteComplianceDocumentDetailById?complianceDocumentDetailId=' + id)
}
// Mahc menu item
export const GetAllMahc = (id) => {
  id = id ? id : ''
  return $.get('api/MahcCode/GetMAHCGrid?number=' + id)
}
export const GetAllMahcCodeAsTree = () => {
  return $.get('api/MahcCode/GetAllMahcCodeAsTree')
}






// WEBPACK FOOTER //
// ./src/pages/Compliance/compliance.service.js